var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackNextAr({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4 21.2C7.09807 21.2 2.8 16.9019 2.8 11.6C2.8 6.29807 7.09807 2 12.4 2C17.7019 2 22 6.29807 22 11.6C22 16.9019 17.7019 21.2 12.4 21.2ZM7.95147 10.7515L11.5515 7.15147C12.0201 6.68284 12.7799 6.68284 13.2485 7.15147C13.7172 7.6201 13.7172 8.3799 13.2485 8.84853L11.6971 10.4L16 10.4C16.6627 10.4 17.2 10.9373 17.2 11.6C17.2 12.2627 16.6627 12.8 16 12.8H11.6971L13.2485 14.3515C13.7172 14.8201 13.7172 15.5799 13.2485 16.0485C12.7799 16.5172 12.0201 16.5172 11.5515 16.0485L7.95147 12.4485C7.48284 11.9799 7.48284 11.2201 7.95147 10.7515Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackNextAr);
export default __webpack_public_path__ + "static/media/black-next-ar.cccad3ecb5e92d1c9f5dfdbb7bd23135.svg";
export { ForwardRef as ReactComponent };